(function () {
    'use strict';

    angular
        .module('Lavpop-store.filters')
        .filter('cep', FormatCEP)

    function FormatCEP() {
        return input => {
            let string = input + '';

            if (string.length == 8)
                return string.replace(/(\d{5})(\d{3})/g, '$1-$2');

            return string;
        }
    }
}());